import client from '../httpClient';

const schedulesDeleteGuidanceByGuidanceIdApi = (pathParameter, queryParam) => {
  return client.delete(`/guidances/${pathParameter}?guidanceDeletedCode=${queryParam}`, { isShowLoading: false });
};

export default schedulesDeleteGuidanceByGuidanceIdApi;
